import apiClient from './ApiService'

export default {
  getCentrosTrabajo(page = 1, limit = 15, filters = {}) {
    return apiClient.get('/centros-trabajo', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  
  getAllCentrosTrabajo(filters = {}) {
    return apiClient.get('/centros-trabajo/all', {
      params: filters
    })
  },
  
  getCentroTrabajo(id) {
    return apiClient.get(`/centros-trabajo/${id}`)
  },
  
  createCentroTrabajo(centroTrabajo) {
    return apiClient.post('/centros-trabajo', centroTrabajo)
  },
  
  updateCentroTrabajo(id, centroTrabajo) {
    return apiClient.put(`/centros-trabajo/${id}`, centroTrabajo)
  },
  
  deleteCentroTrabajo(id) {
    return apiClient.delete(`/centros-trabajo/${id}`)
  }
}